import { getConfig } from '@/utils/config/config';
import { getCookieValue } from '@/utils/cookies/client';
import { COOKIES } from '@/utils/cookies/constants';

/**
 * Returns the MDS WebSocket endpoint URL with the region placeholder resolved.
 * Reads the base URL from config and substitutes the region from the user's cookie.
 */
export const getMdsEndpoint = (): string => {
    const config = getConfig();
    const mdsBaseUrl = config?.apis?.MdsClient?.baseUrl;
    if (!mdsBaseUrl) return '';

    const region = getCookieValue(COOKIES.REGION) as string;
    return mdsBaseUrl.replace('statePlaceholder', region?.toLowerCase() || 'mi');
};
